import { Typography } from '@mui/material'

import { useTranslations } from '@/hooks/useTranslations'

import type React from 'react'
import type { SimpleText as SimpleTextProps } from '@/gen/sanity/schema'

export const SimpleText: React.FC<SimpleTextProps> = ({ Text }) => {
  const { language } = useTranslations()

  return <Typography>{!!Text && Text[language]}</Typography>
}
